import { create } from 'zustand';

interface FirstNoteNudgeState {
  // True only while a brand-new user (no notes yet) should be nudged toward the
  // header "New Note" button. Set by the Home page; read by NewNoteButton.
  isActive: boolean;
  setActive: (active: boolean) => void;
}

export const useFirstNoteNudgeStore = create<FirstNoteNudgeState>((set) => ({
  isActive: false,
  setActive: (active) => set({ isActive: active }),
}));
